import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";

const useStyles = makeStyles((theme: Theme) => ({
    container: {
        display: "flex",
        justifyContent: "center",
        alignItems: "flex-start",
        flexDirection: "column",
        width: "100%",
        color: "#353535",
        letterSpacing: 0,
    },

    container_mobile: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        width: "100%",
        color: "#353535",
        letterSpacing: 0,
    },

    titles_container: {
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
        marginBottom: "16px",
        width: "100%",
    },

    titles_leftSide: {
        width: "15%",
        fontSize: "14px",
    },

    titles_rightSide: {
        display: "flex",
        justifyContent: "space-around",
        alignItems: "center",
        width: "85%",
        marginRight: theme.direction === "ltr" ? "20px" : "0px",
        marginLeft: theme.direction === "rtl" ? "20px" : "0px",
        fontSize: "14px",
    },

    table_container: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        borderRadius: "4px",
        backgroundColor: "#E4F5EC",
        width: "100%",
        padding: "10px",
        color: "#353535",
        letterSpacing: 0,
    },

    tableLeftSide_wideTable: {
        display: "flex",
        justifyContent: "space-around",
        alignItems: "flex-start",
        flexDirection: "column",
        minHeight: "228px",
        width: "15%",
        padding: "0px 12px",
        fontSize: "14px",
    },

    tableRightSide_wideSide: {
        minHeight: "228px",
        borderRadius: "4px",
        backgroundColor: "#FFFFFF",
        width: "100%",
        display: "flex",
        justifyContent: "space-around",
        alignItems: "center",
        flexDirection: "column",
        fontSize: "14px",
    },

    rightSide_row_wideTable: {
        display: "flex",
        justifyContent: "space-around",
        alignItems: "center",
        width: "100%",
    },

    //-------------------------------------------------------------------------------------

    smallLetters: {
        fontSize: "14px",
    },
    smallestLetters: {
        fontSize: "10px",
    },
    titleWidth: {
        width: "152px",
    },
    titleSmallWidth: {
        width: "85px",
        flexDirection: "row",
    },

    inputSmallWidth: {
        width: "40px !important",
    },
    smallFont: { fontSize: " 8px", lineHeight: "10px" },
    inputWideWidth: {
        width: "100px !important",
    },
    textCentered: {
        textAlign: "center",
    },
}));

export default useStyles;
